(() => {
  const packSizePattern = /^(6|24|48)(?:\s*rolls?)?$/i;
  const hasExplicitVariantSelection = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.has('variant') || searchParams.has('option_values');
  };

  const getSelectedPackSize = (productInfo) => {
    const selectedInput = [...productInfo.querySelectorAll('variant-selects input[type="radio"]:checked')].find((input) =>
      packSizePattern.test(input.value.trim())
    );
    const match = selectedInput?.value.trim().match(packSizePattern);

    return match ? match[1] : '';
  };

  const syncPromotion = (productInfo) => {
    const promo = productInfo.querySelector('[data-product-pack-size-promo]');
    if (!promo) return;

    const packSize = getSelectedPackSize(productInfo);
    const material = promo.dataset.material;
    const message = promo.dataset[material + packSize];
    const copy = promo.querySelector('[data-product-pack-size-promo-copy]');
    const legacyPromotion = document.querySelector('.product_page_richtext');

    promo.hidden = !message;
    if (legacyPromotion) legacyPromotion.hidden = true;
    if (message && copy) copy.textContent = message;
  };

  const selectDefaultPackSize = (productInfo) => {
    if (hasExplicitVariantSelection()) return;

    // The promo exists only on the Bamboo and Recycled product pages.
    if (!productInfo.querySelector('[data-product-pack-size-promo]')) return;

    const selectedPackSize = getSelectedPackSize(productInfo);
    if (selectedPackSize === '48') return;

    const defaultInput = [...productInfo.querySelectorAll('variant-selects input[type="radio"]')].find(
      (input) => packSizePattern.test(input.value.trim()) && input.value.trim().match(packSizePattern)?.[1] === '48'
    );

    if (defaultInput && !defaultInput.disabled) defaultInput.click();
  };

  const syncAllPromotions = () => {
    document.querySelectorAll('product-info').forEach(syncPromotion);
  };

  const initialiseProductInfo = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      selectDefaultPackSize(productInfo);
      syncPromotion(productInfo);
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      window.requestAnimationFrame(syncAllPromotions);
    }
  });

  document.addEventListener('DOMContentLoaded', initialiseProductInfo);
  document.addEventListener('shopify:section:load', initialiseProductInfo);
})();
